<template>
  <div class="update-step">
    <div class="update-step_step">
      <div
        style="color: var(--clr-error)"
        class="d-flex"
      >
        <v-icon
          class="mr-2 my-auto"
          size="x-large"
          color="var(--clr-error)"
          >mdi-alert-circle-outline</v-icon
        >
        <h2
          class="my-auto"
          v-html="$t(`payment.errors.${priceError ? 'upgrade_price' : 'unknown_error'}`)"
        ></h2>
      </div>
      <div class="mt-2">
        <h3
          v-if="priceError"
          v-html="$t('payment.errors.please_refresh')"
        ></h3>
        <h3 v-else-if="stripeError ? stripeError.status !== 'CARD_DECLINED' : true">
          {{ $t('payment.error.status_stripe_UNKNOWN_ERROR') }}
          <OpenChatLink />.
        </h3>
        <h3 v-else>
          {{ $t('payment.error.status_stripe_update_CARD_DECLINED') }}
        </h3>
      </div>
    </div>
  </div>
</template>

<script>
import OpenChatLink from '@/components/Payments/OpenChatLink.vue'

export default /** @type {any} */ {
  name: 'FailedPaymentView',
  components: {
    OpenChatLink,
  },
  props: {
    priceError: {
      type: [Boolean, Object],
      default: null,
    },
    stripeError: {
      type: Object,
      default: null,
    },
  },
}
</script>
